//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').ListBasicDataModel>} */

var LIST_DATA_TYPE = {
  data: {
    url: '/backend/lists',
    deleteItemUrl: '/backend/lists/{id}',
    dataKey: 'lists',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView') {
        return {
          query: {
            viewType: options.dataProps.viewType
          }
        };
      }
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        icon: "list",
        text: data.Name,
        app: "People",
        value: "/EOS/Sales/#sales/Lists/".concat(data.Id)
      });
    },
    serverSort: true
  }, {
    id: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    },
    serverSort: false,
    inMemorySort: false,
    width: {
      xs: 0,
      sm: 'auto'
    }
  }, {
    id: 'Type',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Text, {
        value: data.Type
      });
    },
    serverSort: true,
    width: {
      xs: 0,
      sm: 150
    }
  }, {
    id: 'Subscription',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.Text, {
        value: data.AllowContactsToUnsubscribe ? 'Yes' : 'No'
      });
    }
  }, {
    id: 'Size',
    icon: 'contacts',
    formatter: function formatter(_ref5) {
      var data = _ref5.data;
      return React.createElement(Formatter.Text, {
        value: data.Size
      });
    },
    numeric: true,
    serverSort: true,
    width: 130
  }],
  placeholders: {
    type: function type(data) {
      return data ? data.Type + ' list' : 'list';
    },
    label: function label(data) {
      return data.Name;
    },
    icon: function icon(data) {
      return !data || data && !data.Type ? 'list' : data.Type.toLowerCase() === 'dynamic' ? 'list-dynamic' : 'list-static';
    }
  },
  thumbnail: {
    text: function text(data) {
      return data.Name;
    },
    icon: function icon(data) {
      return !data || data && !data.Type ? 'list' : data.Type.toLowerCase() === 'dynamic' ? 'list-dynamic' : 'list-static';
    }
  },
  contextMenu: [{
    label: 'Open'
  }, {
    label: 'New Communication'
  }, 'separator', {
    type: 'delete'
  }]
};
export default LIST_DATA_TYPE;